(function () {
  'use strict';
  if (window.__pdpRowsInit) return;
  window.__pdpRowsInit = true;
  var rows = [].slice.call(document.querySelectorAll('[data-pdp-row]'));
  [].forEach.call(document.querySelectorAll('[data-pdp-static]'), function (el) { initNav(el); });
  if (!rows.length || !window.fetch) return;
  var seen = Object.create(null);

  function fetchCards(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return [].slice.call(tmp.querySelectorAll('[data-pdp-card]'));
      })
      .catch(function () { return []; });
  }

  function usable(cards, row) {
    var exclude = row.getAttribute('data-exclude');
    var dedupe = !row.hasAttribute('data-pdp-nodedupe');
    var local = Object.create(null);
    return cards.filter(function (c) {
      var h = c.getAttribute('data-handle');
      if (!h || h === exclude || (dedupe && seen[h]) || local[h]) return false;
      local[h] = 1;
      return true;
    });
  }

  function initNav(row) {
    var track = row.querySelector('[data-pdp-track]');
    var prev = row.querySelector('[data-pdp-prev]');
    var next = row.querySelector('[data-pdp-next]');
    if (!track || !prev || !next) return;
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 400);
  }

  function afterInsert() {
    try { if (window.SW && SW.collection && SW.collection.checkWishlist) SW.collection.checkWishlist(); } catch (e) {}
    try { if (window.SW && SW.page && SW.page.btnsToolTips) SW.page.btnsToolTips(); } catch (e) {}
    try {
      if (window.woodmart_settings && woodmart_settings.enableCurrency && typeof currenciesCallbackSpecial === 'function') {
        currenciesCallbackSpecial('.pdp-rows span.money, .undersim span.money');
      }
    } catch (e) {}
  }

  function fill(row, cards) {
    var limit = parseInt(row.getAttribute('data-limit'), 10) || 10;
    var track = row.querySelector('[data-pdp-track]');
    cards.slice(0, limit).forEach(function (c) {
      seen[c.getAttribute('data-handle')] = 1;
      track.appendChild(c);
    });
    track.classList.remove('is-loading');
    row.hidden = false;
    initNav(row);
    afterInsert();
    if (row.classList.contains('undersim')) unstickIfTall(row);
  }

  // The theme pins the gallery column (sticky-kit). If the gallery plus this box no longer fits in the viewport, release the pin so the box stays reachable.
  function unstickIfTall(row) {
    if (!window.jQuery) return;
    var $inner = jQuery(row).closest('.product-images-inner');
    if (!$inner.length) return;
    function check() {
      if ($inner.outerHeight() + 60 > window.innerHeight) {
        $inner.trigger('sticky_kit:detach');
        $inner.css({ position: '', top: '', width: '' });
      } else {
        jQuery(document.body).trigger('sticky_kit:recalc');
      }
    }
    check();
    setTimeout(check, 1500);
    setTimeout(check, 4000);
  }

  var jobs = rows.map(function (row) {
    var srcs = (row.getAttribute('data-src') || '').split('|').filter(Boolean);
    return { row: row, srcs: srcs, first: srcs.length ? fetchCards(srcs[0]) : Promise.resolve([]) };
  });

  Promise.all(jobs.map(function (j) { return j.first; })).then(function (firsts) {
    var chain = Promise.resolve();
    jobs.forEach(function (j, i) {
      chain = chain.then(function () {
        var min = parseInt(j.row.getAttribute('data-min'), 10) || 1;
        var cards = usable(firsts[i], j.row);
        var k = 1;
        function tryNext() {
          if (cards.length >= min || k >= j.srcs.length) {
            if (cards.length >= min) fill(j.row, cards); else j.row.parentNode.removeChild(j.row);
            return;
          }
          return fetchCards(j.srcs[k++]).then(function (more) {
            var u = usable(more, j.row);
            if (u.length > cards.length) cards = u;
            return tryNext();
          });
        }
        return tryNext();
      });
    });
    return chain;
  });
})();